/**
 * @fileoverview Yes/No options configuration for GEAO onboarding forms
 */

/**
 * @typedef {Object} YesNoOption
 * @property {string} value - The string value representing the boolean choice ("true" or "false")
 * @property {string} label - The display label for the option ("Yes" or "No")
 */

/**
 * Frozen array of yes/no options for form selection components.
 * Used in GEAO onboarding forms where boolean choices need to be presented
 * as dropdown or radio button options with string values.
 * 
 * @type {ReadonlyArray<YesNoOption>}
 * @constant
 * @default
 * 
 * @example
 * // Usage in a form component
 * import YesNoOptions from './constants/options/YesNoOptions';
 * 
 * const SelectField = () => (
 *   <select>
 *     {YesNoOptions.map(option => (
 *       <option key={option.value} value={option.value}>
 *         {option.label}
 *       </option>
 *     ))}
 *   </select>
 * );
 */
export default Object.freeze([
    { value: "true", label: "Yes" },
    { value: "false", label: "No" }
]);